import React, { useState, useRef, useEffect } from "react";
import { LuSettings2 } from "react-icons/lu";
import { GoSun, GoMoon } from "react-icons/go";
import ToggleBtn from "../button/ToggleBtn";

const SettingsPopover = ({ mealTiming, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleLunchChange = (nextOn) => {
    const isDinnerOn = mealTiming === "all" || mealTiming === "dinner";

    if (!nextOn && !isDinnerOn) {
      // dono off ho rahe → dinner ko on kar do
      onChange("dinner");
      return;
    }

    if (nextOn && isDinnerOn) {
      onChange("all");
    } else if (nextOn) {
      onChange("lunch");
    } else {
      onChange("dinner");
    }
  };

  const handleDinnerChange = (nextOn) => {
    const isLunchOn = mealTiming === "all" || mealTiming === "lunch";

    if (!nextOn && !isLunchOn) {
      // dono off ho rahe → lunch ko on kar do
      onChange("lunch");
      return;
    }

    if (nextOn && isLunchOn) {
      onChange("all");
    } else if (nextOn) {
      onChange("dinner");
    } else {
      onChange("lunch");
    }
  };
  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={ref}>
      {/* Trigger Button */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="border border-gray-200 rounded-md p-2 cursor-pointer bg-white"
      >
        <LuSettings2 />
      </button>

      {/* Popover */}
      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="p-3 space-y-2">
            <div className="flex justify-between gap-4">
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <GoSun size={14} />
                <span>Lunch</span>
              </div>

              <div>
                <ToggleBtn
                  size={35}
                  isOn={mealTiming === "all" || mealTiming === "lunch"}
                  onChange={handleLunchChange}
                />
              </div>
            </div>
            <div className="flex justify-between gap-4">
              <div className="flex items-center gap-2 text-sm text-gray-700">
                <GoMoon size={14} />
                <span>Dinner</span>
              </div>
              <div>
                <ToggleBtn
                  size={35}
                  isOn={mealTiming === "all" || mealTiming === "dinner"}
                  onChange={handleDinnerChange}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingsPopover;
